export const sourceBaseForImage = "./build/images";
